import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
  width: 100%;
  height: auto;

  display: flex;
  flex-direction: column;

  background-color: ${theme.colors.white.Branco};

  @media (max-width: 768px) {
    height: auto;
  }
`;

export const LogoHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 20px;

  img {
    max-width: 180px;
    width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    padding: 16px 20px;

    img {
      max-width: 140px;
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 24px 20px 32px;

  gap: 32px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const ContainerInputs = styled.div`
  width: 100%;
  height: auto;

  gap: 24px;
  display: flex;
  align-items: center;
  flex-direction: column;

  >div:nth-of-type(4),
  >div:nth-of-type(5),
  >div:last-child{
    >div>div>select{
      color: ${theme.colors.gray.Cinza_2} !important;
    }
  }

  >div {
    input:-webkit-autofill { 
      transition: background-color 600000s 0s !important;
    }
  }
  
  >div >div{
    input:-webkit-autofill {
      transition: background-color 600000s 0s !important;
    }

    >button{
      top: 55% !important;
    }
  }

  >div:nth-of-type(10){
    >div>input{
      text-transform: uppercase;
    }
  }
`;

export const ContainerButtonDataUser= styled.div`
  width: 100%;
  height: auto;
  max-width: 420px;

  display: flex;
  align-items: start;
`

export const ButtonCopyDataUser = styled.button`
  all: unset;

  width: 100%;  
  height: auto;
  max-width: 188px;
  padding: 8px 12px;

  >p{
    cursor: pointer;
  }
`

export const DescriptionPrice = styled.div`
  width: 100%;
  height: auto;
  padding: 16px;
  max-width: 420px;

  gap: 16px;
  display: flex;
  flex-direction: column;

  border-radius: 8px;
  background-color: ${theme.colors.gray.Cinza_13};
`;

export const ContainerCupomPriceDiscount = styled.div`
  width: 100%;
  height: auto;

  display: flex;
  flex-direction: column;

  border-bottom: 2px solid ${theme.colors.gray.Cinza_11};
`;

export const CupomPriceDiscount = styled.div`
  width: 100%;
  height: auto;

  gap: 16px;
  display: flex;
  margin-bottom: 8px;
  justify-content: center;

  >p{
    width: 130px;
  }

  >p:first-child{
    text-align: right;
  }
`;

export const TotalPrice = styled.div`
  width: 100%;
  height: auto;

  gap: 16px;
  display: flex;
  justify-content: center;
`;

export const ContainerCardPlans = styled.div`
  width: 100%;
  height: auto;
  max-width: auto;

  display: flex;
  gap: ${({grid}) => (grid ? "8px" : "24px")};
  flex-wrap: wrap !important;
  justify-content: ${({grid}) => (grid ? "center" : " space-evenly")};

  flex-wrap: ${({selectedPlan}) => 
    selectedPlan?.label === 'PLANO PRÉ-PAGO' ? "wrap" : "nowrap"
  };

  >div{
    max-width: ${({selectedPlan}) => 
      selectedPlan?.label === 'PLANO PRÉ-PAGO' ? "auto" : "100%"
    };

    >div{
      width: ${({selectedPlan}) => 
      selectedPlan?.label === 'PLANO PRÉ-PAGO' ? '180px' : '180px'};

      >div>p{
        text-align: center;
        white-space: nowrap;
      }
    }
  }

  @media (max-width: 479px) {
    gap: 24px;
    align-items: center;
    flex-direction: column;

    >div{
      width: 100%;
      max-width: 100%;

      >div{
        width: 100%;
      }
    }
  }
`;

export const CardPlansHeader = styled.div`
  width: 100%;
  height: auto;

  display: flex;
  align-items: center;
  flex-direction: column;

  >h6{
    white-space: nowrap;
  }
`;

export const CardPrice = styled.div`
  width: 100%;
  height: auto;

  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const CardFooter = styled.div`
  width: 100%;
  height: auto;

  display: flex;
  align-items: center;
  flex-direction: column;

  > p > b {
    font-weight: ${theme.typography.fontWeight.bold};
  }
`;

export const ContainerForm= styled.div`
  width: 100%;
  height: auto;
  max-width: 420px;

  gap: 24px;
  display: flex;
  align-items: center;
  flex-direction: column;

  >div:nth-of-type(9){
    > div > input{
      text-transform: uppercase;
    }
  }
`

export const ContainerTwoInputs = styled.div`
  width: 100%;
  height: auto;

  gap: 16px;
  display: flex;

  >div:last-child{
    max-width: 80px;

  >div{
    >input{
      padding: 0.875rem 0.6875rem 0.875rem 1rem;
    }

    >label{
      left: 7px;
    }

    > div {
      > select {
          padding: 0.875rem 0.6875rem 0.875rem 1rem;

          color: ${theme.colors.gray.Cinza_2} !important;
          background-color: transparent !important;
          transition: background-color 600000s 0s, color 600000s 0s !important;

          ::-webkit-autofill {
            transition: background-color 600000s 0s, color 600000s 0s !important;
            -webkit-text-fill-color: ${theme.colors.gray.Cinza_2} !important;
          }
        }

        >span {
          right: 12px;
        }
      }

      >div:nth-of-type(2) {
        padding-right: 1.2rem !important;
      }
    }
  }
`

export const ContainerContent = styled.div`
  width: 100%;
  height: auto;

  gap: 32px;
  display: flex;
  flex-direction: column;
`;

export const ContainerCheckbox = styled.div`
  width: auto;
  height: auto;

  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const ContainerInputCheckbox = styled.div`
  width: auto;
  height: auto;

  gap: 12px;
  display: flex;
  align-items: center;

  > p > span {
    cursor: pointer;
    color: ${theme.colors.blue.Azul_link};
  }

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    appearance: none;
    border: 1px solid ${theme.colors.gray.Cinza_11};
    border-radius: 4px;
    cursor: pointer;
    background-color: ${theme.colors.gray.Cinza_13};
    transition: background-color 0.3s, border-color 0.3s;

    &:checked {
      background-color: ${theme.colors.green.Verde_AgroReceita};
      border-color: ${theme.colors.green.Verde_AgroReceita};

      &::after {
        content: "✔";
        color: white;
        font-size: 11px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;

export const ContainerInputCheckboxCenter = styled(ContainerInputCheckbox)`
  justify-content: center;
`;

export const ContainerTextWithInfo = styled.div`
  width: auto;
  height: auto;

  gap: 8px;
  display: flex;
  align-items: center;

`;

export const ButtonSubmit = styled.div`
  width: 100%;
  height: 48px;
  max-width: 420px;
  padding: 12px 32px 12px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 5rem;

  cursor: ${({isDisabled}) => isDisabled ? 'not-allowed' : 'pointer'};
  pointer-events: ${({isDisabled}) => isDisabled ? 'none' : 'auto'};

  background-color: ${({isDisabled}) => isDisabled ? theme.colors.disabled.Fundo_Desabilitado : theme.colors.green.Verde_AgroReceita};

  >p{
    color: ${({isDisabled}) => isDisabled ? theme.colors.disabled.Desabilitado_Medio : theme.colors.white.Branco};
  }
`;

export const ContainerOtherFields = styled.div`
  width: 100%;
  height: auto;

  gap: 24px;
  display: flex;
  flex-direction: column;
  `;

export const ContainerEmailAndButton = styled.div`
  width: 100%;
  height: auto;

  gap: 4px;
  display: flex;
`;

export const ButtonValidEmail = styled.button`
    all: unset;

    width: auto;
    height: auto;
    padding: 0.5rem 0.75rem;

    display: flex;
    align-items: center;

    cursor: ${(props => (props.disabled) ? 'not-allowed' : 'pointer')};

    opacity: ${(props => (props.disabled) ? 0.5 : 1)};

    text-align: center;
    text-transform: uppercase;
    color:  ${(props => (props.disabled) ? theme.colors.disabled.Desabilitado_Medio : theme.colors.blue.Azul_link)};
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extraBold};
    font-size: ${theme.typography.fontSize.tagLineM};
    line-height: ${theme.typography.lineHeight.tagLineM};
    letter-spacing: ${theme.typography.letterSpacing.normal};
`;

export const ContainerModalEmailValid = styled.div`
    width: 100%;
    height: auto;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;

export const ContainerButtonModalValidEmail = styled.div`
    width: 100%;
    height: auto;
    padding: 0.5rem 0.75rem;

    gap: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Loading = styled.div`
    @-webkit-keyframes rotating /* Safari and Chrome */ {
      from {
          -webkit-transform: rotate(0deg);
          -o-transform: rotate(0deg);
          transform: rotate(0deg);
      }
      to {
          -webkit-transform: rotate(360deg);
          -o-transform: rotate(360deg);
          transform: rotate(360deg);
      }
    }
      
    @keyframes rotating {
      from {
          -ms-transform: rotate(0deg);
          -moz-transform: rotate(0deg);
          -webkit-transform: rotate(0deg);
          -o-transform: rotate(0deg);
          transform: rotate(0deg);
      }
      to {
          -ms-transform: rotate(360deg);
          -moz-transform: rotate(360deg);
          -webkit-transform: rotate(360deg);
          -o-transform: rotate(360deg);
          transform: rotate(360deg);
      }
    }
  
  
    width: 20px;
    height: 20px;
    position: relative;
    margin: auto;
  
    background-color: transparent;
    border-top: 1px solid #FFF;
    border-bottom: 1px solid #FFF;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    border-radius: 50%;
    -webkit-animation: rotating 0.7s linear infinite;
    -moz-animation: rotating 0.7s linear infinite;
    -ms-animation: rotating 0.7s linear infinite;
    -o-animation: rotating 0.7s linear infinite;
    animation: rotating 0.7s linear infinite;
  `;
  